import axios from 'axios';

export const getCustomerCockpitProfileApi = async (customerId) => {
  const response = await axios.get(
    `/admin/customer/${customerId}/cockpit-profile`
  );
  return response.data;
};

export const upsertCustomerCockpitProfileApi = async (customerId, data) => {
  const response = await axios.put(
    `/admin/customer/${customerId}/cockpit-profile`,
    data
  );
  return response.data;
};

export const updateFinancialSnapshotFieldApi = async (
  customerId,
  fieldKey,
  data
) => {
  const response = await axios.patch(
    `/admin/customer/${customerId}/cockpit-profile/financial-snapshot/${fieldKey}`,
    data
  );
  return response.data;
};

export const clearFinancialSnapshotApi = async (customerId) => {
  const response = await axios.delete(
    `/admin/customer/${customerId}/cockpit-profile/financial-snapshot`
  );
  return response.data;
};

export const CUSTOMER_STATUS_DISCOVERY = 'Discovery';
export const CUSTOMER_STATUS_SEND_DATA_REQUEST = 'Send data request';
export const CUSTOMER_STATUS_DATA_COLLECTION = 'Data collection';
export const CUSTOMER_STATUS_UNDERWRITING = 'Underwriting';
export const CUSTOMER_STATUS_PASSED = 'Passed';
export const CUSTOMER_STATUS_LOI_TERM_SHEET = 'LOI/Term Sheet';
export const CUSTOMER_STATUS_CONFIRMATORY_CLOSING = 'Confirmatory & Closing';
export const CUSTOMER_STATUS_ON_HOLD_NURTURE = 'On Hold/Nurture';
export const CUSTOMER_STATUS_LIVE = 'Live';
export const CUSTOMER_STATUS_LOST = 'Lost';
export const CUSTOMER_STATUS_STOPPED = 'Stopped';

export const CUSTOMER_STATUS_OPTIONS = [
  { value: CUSTOMER_STATUS_DISCOVERY, label: 'Discovery' },
  { value: CUSTOMER_STATUS_SEND_DATA_REQUEST, label: 'Send data request' },
  { value: CUSTOMER_STATUS_DATA_COLLECTION, label: 'Data collection' },
  { value: CUSTOMER_STATUS_UNDERWRITING, label: 'Underwriting' },
  { value: CUSTOMER_STATUS_PASSED, label: 'Passed' },
  { value: CUSTOMER_STATUS_LOI_TERM_SHEET, label: 'LOI/Term Sheet' },
  {
    value: CUSTOMER_STATUS_CONFIRMATORY_CLOSING,
    label: 'Confirmatory & Closing',
  },
  { value: CUSTOMER_STATUS_ON_HOLD_NURTURE, label: 'On Hold/Nurture' },
  { value: CUSTOMER_STATUS_LIVE, label: 'Live' },
  { value: CUSTOMER_STATUS_LOST, label: 'Lost' },
  { value: CUSTOMER_STATUS_STOPPED, label: 'Stopped' },
];

export const getCustomerPipelineApi = async () => {
  const response = await axios.get('/admin/customer-pipeline');
  return response.data;
};
